import { IconProps } from "../../types/utils";

const FlagIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 40}
    height={dimension || 40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="19.5" cy="19.5" r="19.5" fill={color || "#F6CB7A"} />
    <path
      d="M14.75 15.25V27.25"
      stroke="white"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.25 15.25V22"
      stroke="white"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.75 15.2499C15.451 14.5628 16.3934 14.178 17.375 14.178C18.3566 14.178 19.299 14.5628 20 15.2499C20.701 15.937 21.6434 16.3219 22.625 16.3219C23.6066 16.3219 24.549 15.937 25.25 15.2499"
      stroke="white"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.75 21.9999C15.451 21.3128 16.3934 20.928 17.375 20.928C18.3566 20.928 19.299 21.3128 20 21.9999C20.701 22.687 21.6434 23.0719 22.625 23.0719C23.6066 23.0719 24.549 22.687 25.25 21.9999"
      stroke="white"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FlagIcon;
